import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { moveContentLibraryFileRequested } from 'features/content-library/actions';

export function* moveContentLibraryFileSaga(
  action: ReturnType<typeof moveContentLibraryFileRequested>
) {
  yield call(SignalingSocket.send, { event: 'moveLibraryFile', data: action.payload });
}
